import React from "react"
import modStyl from './index.module.scss'

import poster1 from '../../assets/images/poster-1.jpg'
import poster2 from '../../assets/images/poster-2.jpg'
import poster3 from '../../assets/images/poster-3.jpg'
import { Toast } from "antd-mobile"

type ArticleProps = {
  id: number
  href: string
  title: string
  poster: string
  time: string
}
const Article: React.FC<ArticleProps> = ({ href, poster, time, title })=> {
  const onClick = ()=> {
    Toast.show('敬请期待')
    // window.location.href = href
  }
  return (
    <div onClick={onClick} className={modStyl.articleWrapper}>
      <div className={modStyl.west}>
        <img src={poster} alt=""/>
      </div>
      <div className={modStyl.east}>
        <h2>{title}</h2>
        <p>{time}</p>
      </div>
    </div>
  )
}

export default function Posts() {
  const articles = [
    {id: 1, href: 'https://mp.weixin.qq.com/s/MR4AR-sJ9LPN7-8CtYYsIQ', title: '【为生命加时】最新肺癌医保用药清单丨新增4种靶向药，价格减50%！', time: '2024.02.23', poster: poster1},
    {id: 2, href: 'https://mp.weixin.qq.com/s/ymPcZoaxAeu_hbj2OB0mEQ', title: '肺癌治疗路上的惊喜与挑战丨ALK抑制剂不良反应大揭秘', time: '2024.04.13', poster: poster2},
    {id: 3, href: 'https://mp.weixin.qq.com/s/ZkELAYACaezhInlCa6Q5kw', title: '三分治，七分吃 | 胃癌患者术前术后饮食指南', time: '2024.05.22', poster: poster3},
  ]
  return (
    <>
      {
        articles.map((item)=> <Article key={item.id} {...item}/>)
      }
    </>
  )
}